<template>
  <div ref="radarChart"></div>
</template>

<script>
import {
  radarOption,
  radarSeries,
  radarCategories,
  createRateSlot
} from "@/views/report/indicators/option/radarOption";
import * as echarts from "echarts";
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["radarData"]),
  },
  watch: {
    radarData: {
      deep: true,
      handler(newVal, oldVal) {
        this.initCharts();
      },
    },
  },
  methods: {
    setChartStyle() {
      // this.$refs.radarChart.style.height =
      //   (document.documentElement.clientHeight - 77) / 2 + "px";
    },
    initCharts() {
      var myChart = echarts.init(this.$refs.radarChart);
      // this.$refs.radarChart.style.width = window.innerWidth * 0.8 + 'px';
      // this.$refs.radarChart.style.height =
      //   (document.documentElement.clientHeight - 77) / 2 + "px";
      // this.$refs.radarChart.style.border = "1px solid #E9E9E9";

      const _radarData = {};

      const option = Object.assign({},radarOption);

      radarCategories.forEach((e) => {
        _radarData[e.name] = this.radarData[e.code];
      });

      option.legend.data = Object.keys(_radarData);

      const categories = radarSeries.map((innerObj) => {
        return {
          text: innerObj.name,
          max: 100,
        };
      });

      // 提取内部对象的值，并和外部 key 组成 {name: outerKey, value: [值1, 值2,...]} 数组
      const seriesData = Object.entries(_radarData).map(
        ([outerKey, innerObj]) => {
          const list = [];
          radarSeries.forEach((element) => {
            list.push((parseFloat(innerObj[element.code]) * 100).toFixed(2));
          });
          return {
            name: outerKey,
            value: list,
          };
        }
      );

      // 设置维度
      option.series[0].data = seriesData;
      option.polar[0].indicator = categories;
      option.tooltip.formatter = createRateSlot(radarSeries.map(o=>o.name));
      myChart.setOption(option);

      myChart.resize();
      const resizeHandler = () => {
        this.setChartStyle();
        myChart && myChart.resize();
      };

      window.addEventListener("resize", resizeHandler);
    },
  },
  created() {},
  mounted() {
    // this.getIndexMsg();
  },
};
</script>

<style lang="scss">
// #lineDiv {
//   width: 500px;
//   height: 300px;
//   border: 1px solid red;
// }
</style>
